module.exports = __webpack_public_path__ + "static/media/42.e1c2d6b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/42.jpg
// module id = 732
// module chunks = 0